import { fork, take, put, call } from 'redux-saga/effects'
import {
  EMPLOYEE_PERMISSION_PAGE_REQUEST,
  EMPLOYEE_PERMISSION_SUBMIT_FORM,
  EMPLOYEE_PERMISSION_CHANGE_PAGE
} from 'actions/employees/permission/constants'
import {initialize, reset} from 'redux-form'
import * as apiSetting from 'api/settings'
import * as actNotif from 'actions/notifications'
import * as act from 'actions'
import * as actPermission from 'actions/employees/permission'
import {push} from 'react-router-redux'

export function * fillForm (setting) {
  let form = {
    allowStaffRefund: setting.allow_staff_refund,
    authCode: setting.auth_code,
    staffDeleteBill: setting.staff_delete_bill,
    staffResendReceipt: setting.staff_resend_receipt
  }
  yield put(initialize('permission', form))
}

export function * pageRequest () {
  // noinspection InfiniteLoopJS
  while (true) {
    yield take(EMPLOYEE_PERMISSION_PAGE_REQUEST)
    try {
      yield put(act.sendingRequest(true))
      yield put(act.showProgressBar())
      let response = yield call(apiSetting.getSettings)
      yield put(actPermission.setSetting(response.data[0]))
      yield call(fillForm, response.data[0])
    } catch (error) {
      yield put(actNotif.error(error.message))
    } finally {
      yield put(act.sendingRequest(false))
      yield put(act.hideProgressBar())
    }
  }
}

export function * submitForm () {
  // noinspection InfiniteLoopJS
  while (true) {
    let {payload: {data}} = yield take(EMPLOYEE_PERMISSION_SUBMIT_FORM)
    try {
      yield put(act.sendingRequest(true))
      yield put(act.showProgressBar())
      let response = yield call(apiSetting.putUpdateSetting, data)
      yield put(actNotif.success(response.data.message))
      yield call(fillForm, response.data)
    } catch (error) {
      yield put(actNotif.error(error.message))
    } finally {
      yield put(act.sendingRequest(false))
      yield put(act.hideProgressBar())
    }
  }
}

export function * changePage () {
  // noinspection InfiniteLoopJS
  while (true) {
    let {payload: {pathname}} = yield take(EMPLOYEE_PERMISSION_CHANGE_PAGE)
    // reset the form and change page, to make it clean and pass validation
    yield put(reset('permission'))
    yield put(push(pathname))
  }
}

export default function * saga () {
  yield fork(pageRequest)
  yield fork(submitForm)
  yield fork(changePage)
}



// WEBPACK FOOTER //
// ./app/sagas/employees/permission.js